export const getPseudonymCount = (state) =>
    state.pseudonym.pseudonyms.maxCount;